import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  const teamMembers = [
    {
      name: 'د. فهمي المطري',
      role: 'المؤسس والمدير التنفيذي',
      description: 'خبير في مجال دعم المواهب الأدبية مع أكثر من 15 عام من الخبرة',
      image: 'fas fa-user-tie'
    },
    {
      name: 'أ. سارة أحمد',
      role: 'مديرة البرامج الأدبية',
      description: 'متخصصة في تطوير البرامج التدريبية للكتاب والشعراء',
      image: 'fas fa-user-graduate'
    },
    {
      name: 'أ. محمد حسن',
      role: 'مدير المعارض الفنية',
      description: 'خبير في تنظيم المعارض الفنية ودعم الفنانين التشكيليين',
      image: 'fas fa-palette'
    },
    {
      name: 'أ. نور الدين',
      role: 'مدير العلاقات الإعلامية',
      description: 'متخصص في الإعلام والعلاقات العامة والحوارات الصحفية',
      image: 'fas fa-microphone'
    }
  ];

  const achievements = [
    {
      number: '500+',
      title: 'موهبة مدعومة',
      description: 'كاتب وفنان استفادوا من برامجنا'
    },
    {
      number: '150+',
      title: 'كتاب منشور',
      description: 'إصدارات تم نشرها عبر مؤسستنا'
    },
    {
      number: '50+',
      title: 'معرض فني',
      description: 'معارض نظمناها لعرض الأعمال الفنية'
    },
    {
      number: '200+',
      title: 'حوار صحفي',
      description: 'لقاءات مع كتاب وفنانين مبدعين'
    }
  ];

  const services = [
    {
      icon: 'fas fa-book-open',
      title: 'النشر والتوزيع',
      description: 'نساعد الكتاب في نشر أعمالهم بأعلى جودة وأقل تكلفة'
    },
    {
      icon: 'fas fa-chalkboard-teacher',
      title: 'التدريب والتطوير',
      description: 'ورش عمل ودورات تدريبية لتطوير المهارات الأدبية والفنية'
    },
    {
      icon: 'fas fa-users',
      title: 'التواصل والشبكات',
      description: 'ربط المواهب ببعضها البعض وبالجمهور المهتم'
    },
    {
      icon: 'fas fa-trophy',
      title: 'المسابقات والجوائز',
      description: 'تنظيم مسابقات أدبية وفنية مع جوائز قيمة'
    },
    {
      icon: 'fas fa-globe',
      title: 'المنصات الرقمية',
      description: 'عرض الأعمال على منصات إلكترونية متطورة'
    },
    {
      icon: 'fas fa-handshake',
      title: 'الشراكات',
      description: 'التعاون مع مؤسسات ثقافية وأدبية محلية وعربية'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="hero-content">
            <h1>من نحن</h1>
            <p>بصمة آثر وآركان أكاديمي - رحلة في عالم الإبداع والمواهب</p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="our-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>قصتنا</h2>
              <p>
                بدأت رحلتنا من حلم بسيط: أن نكون الجسر الذي يربط بين المواهب الأدبية والفنية وبين الجمهور المحب للإبداع. 
                في عام 2020، أسسنا "بصمة آثر وآركان أكاديمي" لتكون منارة للمبدعين والمواهب في العالم العربي.
              </p>
              <p>
                إيماناً منا بأن كل موهبة تستحق الدعم والرعاية، عملنا على تطوير برامج شاملة تغطي جميع جوانب الإبداع، 
                من الكتابة والشعر إلى الفنون التشكيلية والرقمية. هدفنا ليس فقط اكتشاف المواهب، بل تنميتها ودعمها 
                حتى تصل إلى أقصى إمكاناتها.
              </p>
              <p>
                اليوم، نفخر بأننا ساعدنا المئات من الكتاب والفنانين على تحقيق أحلامهم، ونشرنا عشرات الكتب، 
                ونظمنا العديد من المعارض الفنية والفعاليات الثقافية. رحلتنا مستمرة، وحلمنا يكبر مع كل موهبة جديدة تنضم إلينا.
              </p>
            </div>
            <div className="story-image">
              <div className="image-placeholder">
                <i className="fas fa-lightbulb"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <div className="mv-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h3>رسالتنا</h3>
              <p>
                دعم وتنمية المواهب الأدبية والفنية في العالم العربي من خلال توفير منصات متطورة للنشر والعرض، 
                وبرامج تدريبية متخصصة، وبيئة محفزة للإبداع والتميز.
              </p>
            </div>
            <div className="mv-card">
              <div className="mv-icon">
                <i className="fas fa-eye"></i>
              </div>
              <h3>رؤيتنا</h3>
              <p>
                أن نكون المؤسسة الرائدة في دعم المواهب الأدبية والفنية، وأن نساهم في إثراء المشهد الثقافي العربي 
                بأعمال إبداعية متميزة تعكس هويتنا وتواكب العصر.
              </p>
            </div>
            <div className="mv-card">
              <div className="mv-icon">
                <i className="fas fa-heart"></i>
              </div>
              <h3>قيمنا</h3>
              <ul>
                <li>الإبداع والتميز</li>
                <li>الدعم والتشجيع</li>
                <li>الجودة والاحترافية</li>
                <li>التطوير المستمر</li>
                <li>الشراكة والتعاون</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="our-services">
        <div className="container">
          <h2 className="section-title">خدماتنا</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="achievements">
        <div className="container">
          <h2 className="section-title">إنجازاتنا</h2>
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div key={index} className="achievement-card">
                <div className="achievement-number">{achievement.number}</div>
                <h3>{achievement.title}</h3>
                <p>{achievement.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="our-team">
        <div className="container">
          <h2 className="section-title">فريق العمل</h2>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="member-image">
                  <i className={member.image}></i>
                </div>
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="member-role">{member.role}</p>
                  <p className="member-description">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>انضم إلى عائلتنا الإبداعية</h2>
            <p>
              هل أنت كاتب موهوب؟ فنان مبدع؟ شاعر متميز؟ 
              نحن هنا لندعمك ونساعدك على تحقيق أحلامك الإبداعية
            </p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-primary">تواصل معنا</a>
              <a href="/books" className="btn btn-secondary">تصفح أعمالنا</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
